import { Record } from "@baseline/common";
import { DefaultEventEmitter } from "@baseline/runtime/events";
import { Module } from "@baseline/runtime/webpack/module";
import { StyleModule } from "@baseline/styles";
import React, { FC, useEffect, useMemo } from "react";
import { Style } from "./style";
import { useListener } from "./use-listener";
import { useUpdate } from "./use-update";


export const StyleModules: FC<{}> =
    ({ }) =>
    {
        const manager = useMemo(() => new StylesManager(), []);
        useEffect(() => () => manager.dispose(), []);
        const update = useUpdate();
        useListener(manager, "update", update);

        const modules = Record.entries(manager.modules);

        return (
            <>
                {
                    modules.map(
                        ([id, module]) => (
                            <Style key={id} id={id} content={module.exports.styleSource} />
                        )
                    )
                }
            </>
        );
    };


class StylesManager extends DefaultEventEmitter<Event>
{
    constructor()
    {
        super();
        this.onModuleLoad = this.onModuleLoad.bind(this);
        Module.on("load", this.onModuleLoad);

        this.refresh();
    }

    dispose(): void
    {
        Module.off("load", this.refresh);
    }

    modules: Record<string, StyleModule> = {};

    private refresh(): void
    {
        // Get all style modules
        const modules = StyleModule.getStyleModules();

        // Enable hot module reloading
        modules.forEach(module => module.hot?.accept());

        // Update modules
        this.modules =
            Record.from(
                modules.map(
                    module => [StyleModule.getStyleModuleId(module), module]
                )
            );

        // Emit
        this.emit("update");
    }

    private onModuleLoad(module: StyleModule): void
    {
        if (!StyleModule.isStyleModule(module))
            return;

        module.hot?.accept();

        const id = StyleModule.getStyleModuleId(module);
        this.modules[id] = module;

        this.emit("update");
    }
}


type Event = "update";
